import { render, staticRenderFns } from "./AudienceCustomersList.vue?vue&type=template&id=595d8091&"
import script from "./AudienceCustomersList.vue?vue&type=script&lang=js&"
export * from "./AudienceCustomersList.vue?vue&type=script&lang=js&"
import style0 from "./AudienceCustomersList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports